<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Employee History</h2>
        </div>  

                       <div class="card flex gap-6">
                        <h1 class="text-black-500">Name: {{ empdetails.empname }}</h1>
                        <h1 class="text-black-500">Contact: {{ empdetails.empcontact }}</h1>
                        <h1 class="text-black-500">
                            Status: {{ empdetails.empstatus == 1 ? 'Active' : (empdetails.empstatus == 2 ? 'De- Active' : 'Unknown') }}
                            </h1>

                        </div>

<div class="card p-2">
    <div class="flex flex-wrap items-end gap-4">
        <!-- From Date -->
        <div>
            <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
            <input
                type="date"
                id="startDate"
                v-model="filter.startDate"
                class="p-2 border border-gray-300 rounded w-full"
            />
        </div>

        <!-- To Date -->
        <div>
            <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
            <input
                type="date"
                id="endDate"
                v-model="filter.endDate"
                class="p-2 border border-gray-300 rounded w-full"
            />
        </div>

        <div>
            <label for="status" class="block text-sm font-medium text-gray-700">Status</label>
            <select
                id="status"
                v-model="filter.status"
                class="p-2 border border-gray-300 rounded w-full"
            >
                <option value="0">Pending</option>
                <option value="1">Processing</option>
                <option value="2">Complete</option>
            </select>
        </div>


        <!-- Filter Button -->
        <div class="self-end mt-6">
            <button
                type="submit"
                @click="getFilterBasics(1)"
                class="btn btn-primary-solid px-5 py-2 rounded cursor-pointer"
            >
                Filter
            </button>
        </div>
    </div>
</div>


          
     
                 <div class="card">
                       <h3 class="card-title">Order Details</h3>
                   </div>
        <div class="grid grid-cols-12">

            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                  
                    <div class="p-6 space-y-4 overflow-x-auto">
                        <table id="datatable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Bill No</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Customer Name</th>
                                    <th class="bg-[#B2E8D9]">Product Name</th>
                                    <th class="bg-[#B2E8D9]">Qty</th>
                                    <th class="bg-[#B2E8D9]">Status</th>
                                    <th class="bg-[#B2E8D9]">Processing<br>Date</th>
                                    <th class="bg-[#B2E8D9]">Complete<br>Date</th>
                                    <!-- <th class="bg-[#B2E8D9]">View</th> -->
                                  
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in totalorders" >
                                    <td>{{item.id}}</td>
                                      <td>
                                        {{ item.entrydate.endsWith('00:00:00') ? item.entrydate.split(' ')[0] + ' --' : item.entrydate }}
                                        </td>

                                    <td >{{item.cust_name}}</td>
                                    <td class="text-info">{{item.prd_name}}</td>
                                    <td class="text-danger">{{item.pieceqty}}({{item.meterqty}})</td>
                                    <td :class="{
                                        'text-warning': item.markstatus == 0,
                                        'text-primary': item.markstatus == 1,
                                        'text-success': item.markstatus == 2
                                        }">
                                    {{
                                        item.markstatus == 0
                                        ? 'Pending'
                                        : item.markstatus == 1
                                        ? 'Processing'
                                        : item.markstatus == 2
                                        ? 'Complete'
                                        : ''
                                    }}
                                    </td>
                                      <td>{{ item.processing_date === '0000-00-00 00:00:00' ? '--' : item.processing_date }}</td>
                                      <td>{{ item.complete_date === '0000-00-00 00:00:00' ? '--' : item.complete_date }}</td>
                                    <!-- <td> <button class="btn-icon btn-primary-icon-light size-7" @click="show_status(item.id)" >
                                                                                    <i class="ri-eye-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                                                    </button></td> -->
                                  
                                </tr>
                            </tbody>

                             <!-- <tfoot class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr style="background:rgb(226 232 240 / 0.5)">

                                    <td colspan="3"></td>
                                     <td class="text-info">{{FinalDet.paid}}</td>
                                     <td class="text-danger">{{FinalDet.total}}</td>
                                     <td>{{FinalDet.discount}}</td>
                                  
                                  
                                </tr>
                            </tfoot> -->
                         
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->

        </div>



<!-- Account History -->
                  <div class="card">
                       <h3 class="card-title">Account Details</h3>
                   </div>


<div class="card p-2">
    <div class="flex flex-wrap items-end gap-4">
        <!-- From Date -->
        <div>
            <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
            <input
                type="date"
                id="startDate"
                v-model="filter.startDate"
                class="p-2 border border-gray-300 rounded w-full"
            />
        </div>

        <!-- To Date -->
        <div>
            <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
            <input
                type="date"
                id="endDate"
                v-model="filter.endDate"
                class="p-2 border border-gray-300 rounded w-full"
            />
        </div>

        <!-- Filter Button -->
        <div class="self-end mt-6">
            <button
                type="submit"
                @click="getFilterBasics"
                class="btn btn-primary-solid px-5 py-2 rounded cursor-pointer"
            >
                Filter
            </button>
        </div>
    </div>
</div>






        <div class="grid grid-cols-12">

            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                  
                    <div class="p-6 space-y-4 overflow-x-auto">
                        <table id="datatable2" class="datatable2">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Tr No</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Total</th>
                                    <th class="bg-[#B2E8D9]">Paid</th>
                                    <th class="bg-[#B2E8D9]">Note</th>
                    
                                    <!-- <th class="bg-[#B2E8D9]">View</th> -->
                                  
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in empaccounting" >
                                    <td>{{item.id}}</td>
                                    <td>{{item.entrydate}}</td>
                                    <td >{{item.total}}</td>
                                    <td class="text-info">{{item.paid}}</td>
                                    <td class="text-danger">{{item.note}}</td>
                                    
                                    <!-- <td> <button class="btn-icon btn-primary-icon-light size-7" @click="show_status(item.id)" >
                                                                                    <i class="ri-eye-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                                                    </button></td> -->
                                  
                                </tr>
                            </tbody>

                             <!-- <tfoot class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr style="background:rgb(226 232 240 / 0.5)">

                                    <td colspan="3"></td>
                                     <td class="text-info">{{FinalDet.paid}}</td>
                                     <td class="text-danger">{{FinalDet.total}}</td>
                                     <td>{{FinalDet.discount}}</td>
                                  
                                  
                                </tr>
                            </tfoot> -->
                         
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->

        </div>
<!-- Account History -->





















        </div> -->
<!-- table for cust Accounting -->



</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'SaleList',
components: {

} ,
mounted(){


    if (this.$route.query.q) {
           this.getBasics(this.$route.query.q);
    }else{
       this.getBasics();
    }
},
data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     saleList:[],
     orderstatus:[],
     showModel:false,
     datatable:null,

 
     totalorders:[],
     empaccounting:[],
     empdetails:[],

     Final:{total:0,paid:0,payable:0,discount:0},
     FinalDet:{total:0,paid:0,discount:0},
     showModel:false,
     account:{entrydate:this.todayDate(),paid:0,cust_id:0,note:''},
       filter:{
            startDate:this.getStartDate(),
            endDate:today,
            filterid:'',
            status:''
        },

     
 }
 },
methods:{
    
   getStartDate() {
      let startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      //startDate.setDate(1); // Set to the 1st of the month
      return startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    },


                       
 async getBasics(id) {
       var self=this;
       self.filter.filterid=id;
         axios.post('getorderhistory',{id:id}).then(function (response) {
                self.destroyDatatble();
                  self.totalorders=response.data.totalorders;
                     self.empaccounting=response.data.empaccounting;
                    self.empdetails=response.data.empdetails;
                 self.employees=response.data.userDetails;
                }).then(()=>{
                    self.refreshDatatble();
                    // self.calculateTotal();
                    // self.calculateTotal2();
                  
                    });
  },

     

 refreshDatatble() {
            self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false 
                            });

              self.datatable= $(".datatable2").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false 
                            });






         },
          destroyDatatble() {
                 if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }
                    if ($.fn.dataTable.isDataTable('.datatable2')) {
                        $('.datatable2').DataTable().destroy();
                    }
          },    



        calculateTotal(){
        
            var self=this;

        self.Final=  {total:0,paid:0,payable:0,discount:0};


            Array.from(self.custaccounting).forEach((row) => {
                    self.Final.total+=parseFloat(row.total);
                    self.Final.paid+=parseFloat(row.paid);
                    self.Final.discount+=parseFloat(row.discount);
                    self.Final.payable+=parseFloat(row.total)-parseFloat(row.discount);


            });
        },


   calculateTotal2(){
        
            var self=this;

        self.FinalDet=  {total:0,paid:0,discount:0};


            Array.from(self.totalorders).forEach((row) => {
                    self.FinalDet.total+=parseFloat(row.total);
                    self.FinalDet.paid+=parseFloat(row.paid);
                    self.FinalDet.discount+=parseFloat(row.discount);
                


            });
        },





 closeModal(){

    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
                      $("#accountModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },
     accountModal(id){
      
        if(!this.isAccount)
            $("#accountModal").removeClass('hidden');
        else
            $("#accountModal").addClass('hidden');
            
        this.account.cust_id=id;

    },


 todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate();
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },
    saveAccount() {
                var self = this; 
                if(self.account.paid==0){
                    self.$swal("Please Enter Paid Amount");
                }else  if(self.account.cust_id==0){
                    self.$swal("Customer Not Found");
                }else{
                    axios.post('addAccountVoucherfrom', this.account)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.CustomerList=response.data.list;
                            self.employees=response.data.userDetails;
                             self.Customerdetails=response.data.customerdetails;
                            self.totalorders=response.data.totalorders;
                           self.custaccounting=response.data.custaccounting;
                               self.Customer={name:'',cell:'',address:'',gst:''};

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },

                   getFilterBasics(type) {
                      var self=this;
                       axios.post('getfilterorderhistory',{...self.filter,type: type}).then(function (response) {
                     
                        self.destroyDatatble();
                        self.totalorders=response.data.totalorders;
                            self.empaccounting=response.data.empaccounting;
                            self.empdetails=response.data.empdetails;
                        self.employees=response.data.userDetails;
                        }).then(()=>{
                            self.refreshDatatble();
                            // self.calculateTotal();
                            // self.calculateTotal2();
                        
                            });


                      

                   }


}
}
</script>
